// Admin — Hosted Jobs dashboard. Panggil /admin/* pada Central Worker backend.
// ⚠️ Semua tindakan DISAHKAN DI SERVER (token Firebase → semak admin). Token admin di frontend
//    BUKAN pintu keselamatan — server yang putuskan. Fail-closed bila env tiada.
import { auth } from '../firebase';

const HB_API = (import.meta.env.VITE_HOSTED_BETA_API || '').replace(/\/+$/, '');

export const hostedAdminBolehAktif = () => !!HB_API;

async function adminCall(path, body) {
  if (!HB_API) throw new Error('HOSTED_BETA_DISABLED');
  await auth.authStateReady();
  if (!auth.currentUser) throw new Error('SILA_LOG_MASUK');
  const tok = await auth.currentUser.getIdToken();
  const r = await fetch(HB_API + path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + tok },
    body: JSON.stringify(body || {}),
    credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(20000),
  });
  const j = await r.json().catch(() => null);
  if (!r.ok) { const e = new Error((j && j.error) || ('HTTP_' + r.status)); e.status = r.status; throw e; }
  return j;
}

export const bacaStatsHosted = () => adminCall('/admin/stats', {});
export const bacaJobsHosted = ({ status, uid } = {}) => adminCall('/admin/jobs', { status: status || undefined, uid: uid || undefined });
export const bacaAuditHosted = (limit = 50) => adminCall('/admin/audit', { limit });
export const setPauseHosted = (paused) => adminCall('/admin/pause', { paused: !!paused });
export const adminTandaSiap = (jobId, videoUrl) => adminCall('/admin/mark-done', { jobId, videoUrl: videoUrl || undefined });
export const adminTandaGagal = (jobId) => adminCall('/admin/mark-failed', { jobId });
export const adminJanaSemula = (jobId) => adminCall('/admin/regenerate', { jobId });

// Pilot access control (rollout berperingkat). Default TUTUP — buka secara pilot/all oleh admin.
export const bacaRolloutHosted = () => adminCall('/admin/rollout', {});                 // { rollout, pilotUids }
export const setRolloutHosted = (rollout) => adminCall('/admin/rollout', { rollout });  // 'pilot' | 'all'
export const tambahPilotHosted = (uid) => adminCall('/admin/rollout', { add: uid });
export const buangPilotHosted = (uid) => adminCall('/admin/rollout', { remove: uid });

// Notifikasi batch — status penghantaran email + retry SELAMAT (idempotency key Resend sama).
export const bacaBatchesHosted = (limit = 100) => adminCall('/admin/batches', { limit }); // { batches:[{batchId,email:{status,...}}] }
export const retryBatchEmailHosted = (batchId) => adminCall('/admin/retry-batch-email', { batchId });
